module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loenbroek text-dark"
  }, [_c('h2', {
    staticClass: "marg-1-bottom"
  }, [_vm._v("Lønbrøker")]), _vm._v(" "), (_vm.isNoSDConfiguration) ? [_vm._m(0)] : [_c('div', {
    staticClass: "one-time-supplements__header"
  }, [_c('Tabs', {
    staticClass: "marg-1-bottom",
    attrs: {
      "tabs": _vm.tabsList,
      "selected": _vm.activeFilter
    },
    on: {
      "select": _vm.setFilter
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": 'Personer',
      "tags": _vm.uniqueNames,
      "selectedTags": _vm.selectedNames,
      "numberOfSelectedTagsToShow": 2,
      "placeholder": 'Vælg personer'
    },
    on: {
      "select": _vm.toggleName,
      "clear": _vm.clearNames
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-time-supplements__body"
  }, [(_vm.isLoading) ? _c('Loader') : [(_vm.activeFilter === 'draft') ? _c('div', {
    staticClass: "do-table__filters"
  }, [_c('span', {
    staticClass: "loenbroek__info"
  }, [_vm._v("\n            Lønbrøker i udbakken sendes automatisk til lønsystemet senere på dagen. Du kan redigere eller slette dem, så længe de ligger her.\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.createLoenbroek
    }
  }, [_vm._v("\n            Opret lønbrøk\n          ")])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "do-table",
    class: {
      'do-table--can-edit': _vm.activeFilter === 'draft'
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "th-sorter td-created",
    class: {
      'th-sorter--active': !_vm.isSortPristine && _vm.sortBy === 'vCreatedAt'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('vCreatedAt')
      }
    }
  }, [_vm._v("\n              Oprettet "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortBy === 'name'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('name')
      }
    }
  }, [_vm._v("\n              Navn "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortBy === 'tjenestenummer'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('tjenestenummer')
      }
    }
  }, [_vm._v("\n              Tjenestenummer "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter td-date",
    class: {
      'th-sorter--active': _vm.sortBy === 'date'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('date')
      }
    }
  }, [_vm._v("\n              Dato "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortBy === 'aarstimetal'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('aarstimetal')
      }
    }
  }, [_vm._v("\n              Årsnorm "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortBy === 'loendecimal'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('loendecimal')
      }
    }
  }, [_vm._v("\n              Løndecimal "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortBy === 'beskaeftigelsesdecimal'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('beskaeftigelsesdecimal')
      }
    }
  }, [_vm._v("\n              Beskæftigelsesdecimal "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), (_vm.activeFilter === 'sent') ? _c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortBy === 'vApprovedAt'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('vApprovedAt')
      }
    }
  }, [_vm._v("\n              Sendt til lønsystem "), _c('span', {
    staticClass: "icon-menu-open"
  })]) : _vm._e(), _vm._v(" "), (_vm.activeFilter === 'sent') ? _c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortBy === 'vApprovedBy'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('vApprovedBy')
      }
    }
  }, [_vm._v("\n              Godkendt af "), _c('span', {
    staticClass: "icon-menu-open"
  })]) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.displayedLoenbroeker.length === 0) ? _c('tr', [_c('td', {
    staticClass: "italic",
    attrs: {
      "colspan": _vm.activeFilter === 'sent' ? 9 : 7
    }
  }, [_vm._v("\n              Ingen lønbrøker fundet\n            ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.displayedLoenbroeker), function(item) {
    return _c('tr', {
      key: item.id,
      on: {
        "click": function($event) {
          return _vm.setEditItem(item)
        }
      }
    }, [_c('td', {
      staticClass: "td-created"
    }, [_vm._v(_vm._s(item.vCreatedAt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vUserName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.tjenestenummer))]), _vm._v(" "), _c('td', {
      staticClass: "td-date"
    }, [_vm._v(_vm._s(item.vDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.aarstimetal || '—'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.loendecimal != null ? _vm.formatDecimal(item.loendecimal) : '—'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.beskaeftigelsesdecimal != null ? _vm.formatDecimal(item.beskaeftigelsesdecimal) : '—'))]), _vm._v(" "), (_vm.activeFilter === 'sent') ? _c('td', [_vm._v(_vm._s(item.vApprovedAt))]) : _vm._e(), _vm._v(" "), (_vm.activeFilter === 'sent') ? _c('td', [_vm._v(_vm._s(item.vApprovedBy))]) : _vm._e()])
  })], 2)])]], 2)], _vm._v(" "), (_vm.isShowLoenbroekModal) ? _c('LoenbroekModal', {
    attrs: {
      "theEditItem": _vm.theEditItem
    },
    on: {
      "close": function($event) {
        _vm.isShowLoenbroekModal = false
      },
      "created": _vm.onCreated,
      "deleted": _vm.onDeleted
    }
  }) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "one-time-supplements-no-sd"
  }, [_c('h2', [_c('i', [_vm._v("Skolens SD-integration er ikke konfigureret korrekt. Kontakt Docendo for at få hjælp til opsætningen -\n          enten på chat eller email.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-335ab610!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/Silkeborgdata/Loenbroek.vue
// module id = 1845
// module chunks = 1